import { render, staticRenderFns } from "./GeneralMap.vue?vue&type=template&id=23650c82"
import script from "./GeneralMap.vue?vue&type=script&lang=js"
export * from "./GeneralMap.vue?vue&type=script&lang=js"
import style0 from "./GeneralMap.vue?vue&type=style&index=0&id=23650c82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports